import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import withNotifications from 'shared/hocs/withNotifications';
import NOTIFICATION_TYPES from 'shared/actions/notificationTypes';
import s from './NotificationBar.css';

class NotificationBar extends React.Component {
  static propTypes = {
    activeMessage: PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.string,
    }),
  };
  static defaultProps = {
    activeMessage: null,
  };

  render() {
    const { activeMessage } = this.props;
    const type = activeMessage && activeMessage.type;

    return (
      <div
        className={cx(
          s.root,
          { [s.active]: activeMessage },
          //
          { [s.error]: type === NOTIFICATION_TYPES.ERROR },
          { [s.success]: type === NOTIFICATION_TYPES.SUCCESS },
          { [s.warning]: type === NOTIFICATION_TYPES.WARNING },
          { [s.info]: type === NOTIFICATION_TYPES.INFO },
        )}
      >
        {activeMessage &&
          <div className={s.label}>
            {activeMessage.text}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(withNotifications(NotificationBar));



// WEBPACK FOOTER //
// ./src/desktop/components/Layout/NotificationBar/NotificationBar.js